import { RouteConfig } from 'vue-router';
const Folder = () => import('./views/folder.vue');
const Add = () => import('./views/add.vue');
const Auto = () => import('./views/auto.vue');
const routers: RouteConfig[] = [
    {
        path: 'folder',
        name: 'folder',
        component: Folder
    },
    {
        path: 'add',
        name: 'add',
        component: Add
    },
    {
        path: 'auto',
        name: 'auto',
        component: Auto
    },
    {
        path: '',
        redirect: 'folder'
    },
];
export default routers;

